import { isEqual } from 'lodash/fp';
import React, { useCallback, useMemo, useState } from 'react';

import { CalculatorField } from '../../../admin/calculator/store';
import { Calculator } from '../../calculator/Calculator';
import { Calculator as CalculatorIcon } from '../../icons';
import { ConfirmationModal } from '../../modal/ConfirmationModal';
import { ModalHeader } from '../../modal/ModalHeader';
import styles from './RiskField.module.scss';

interface CalculatorRiskFieldModalProps {
    initialCalculatorValue: CalculatorField[];
    width: number;
    closeModal: () => void;
    saveCalculatorExample: (value: CalculatorField[]) => void;
    showGracePeriod: boolean;
    showOutput: boolean;
    fieldType: string;
    label: string;
    riskAssociated: string;
}

export const CalculatorRiskFieldModal: React.FC<CalculatorRiskFieldModalProps> = ({
    initialCalculatorValue,
    width,
    closeModal,
    saveCalculatorExample,
    showGracePeriod,
    showOutput,
    fieldType,
    label,
    riskAssociated
}) => {
    const [currentCalculatorValue, setCurrentCalculatorValue] = useState<CalculatorField[]>(initialCalculatorValue);

    const hasUpdated = useMemo(() => !isEqual(initialCalculatorValue, currentCalculatorValue), [currentCalculatorValue, initialCalculatorValue]);

    const updateCalculation = useCallback((calculation: CalculatorField[]) => setCurrentCalculatorValue(calculation), []);

    const save = useCallback(() => saveCalculatorExample(currentCalculatorValue), [saveCalculatorExample, currentCalculatorValue]);

    return (
        <ConfirmationModal
            isOpen
            closeModal={closeModal}
            confirmDisabled={!hasUpdated}
            confirmLabel='Save'
            confirm={save}
        >
            <div style={{ width: `${width}px` }}>
                <ModalHeader icon={CalculatorIcon} label={`${label} - ${riskAssociated} Risk Example`} />
                <div className={styles.calculatorRiskModalWrapper}>
                    <Calculator
                        value={currentCalculatorValue}
                        updateValue={updateCalculation}
                        isEditing
                        fieldType={fieldType}
                        width={width}
                        testId='calculator-risk-field'
                        showOutputField={showOutput}
                        showGracePeriod={showGracePeriod}
                    />
                </div>
            </div>
        </ConfirmationModal>
    );
};
